module.exports = __webpack_public_path__ + "static/img/安全通道.887423e6.png";